import IconButton from '@mui/material/IconButton'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import type { GridColDef } from '@mui/x-data-grid-premium'

import { PermissionMeta } from 'graphql'

export default function getColumns(
	onRemovePermission: ( permission: PermissionMeta ) => void,
): GridColDef<PermissionMeta>[] {
	return [
		{
			field: 'friendlyName',
			headerName: 'Permission',
			flex: 1,
		},
		{
			field: 'resourceType',
			headerName: 'Resource',
			width: 140,
		},
		{
			field: 'actions',
			headerName: '',
			width: 96,
			align: 'center',
			headerAlign: 'center',
			renderCell: ( params ) => (
				<IconButton
					size="small"
					aria-label="Remove"
					title="Remove permission"
					onClick={() => onRemovePermission( params.row )}
				>
					<DeleteOutlineIcon fontSize="small" />
				</IconButton>
			),
		},
	]
}
